import { render, staticRenderFns } from "./CNotes.vue?vue&type=template&id=d31000ac&scoped=true&"
import script from "./CNotes.vue?vue&type=script&lang=js&"
export * from "./CNotes.vue?vue&type=script&lang=js&"
import style0 from "./CNotes.vue?vue&type=style&index=0&id=d31000ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31000ac",
  null
  
)

export default component.exports